/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type ConsumptionAmountAmountType = (typeof ConsumptionAmountAmountType)[keyof typeof ConsumptionAmountAmountType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConsumptionAmountAmountType = {
  food: "food",
  drugstore: "drugstore",
  telecommunication: "telecommunication",
  cigarettes: "cigarettes",
  vehicle: "vehicle",
  children: "children",
  gifts: "gifts",
  other: "other",
} as const;
